import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY, COLORS } from '@sortlist-frontend/design-system/legacy';

export const View = styled.div`
  min-height: 100%;
  background: ${COLORS.SECONDARY_100};
  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    background: ${COLORS.NEUTRAL_100};
  }
`;

export const Shape = styled.div`
  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    border-radius: 0;
    box-shadow: none;
  }
`;
